import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { form } from "../Service/Api";
import { getHeader } from "../config";

const validateEmail = (email) => {
  const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return re.test(email);
};

const validatePhone = (phone) => {
  const re = /^\d{10}$/; // Adjust regex according to your needs
  return re.test(phone);
};

const FormAdmissionHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    class: "",
    academicYear: "",
  });

  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [lockClass, setLockClass] = useState(false);

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (!formData.name) {
      errors["name"] = "Name cannot be empty";
      formIsValid = false;
    }
    if (!formData.academicYear) {
      errors["academicYear"] = "Academic Year cannot be empty";
      formIsValid = false;
    }
    if (!formData.class) {
      errors["name"] = "Please Select Class";
      formIsValid = false;
    }

    if (!formData.phone) {
      errors["phone"] = "Phone number cannot be empty";
      formIsValid = false;
    } else if (!validatePhone(formData.phone)) {
      errors["phone"] = "Invalid phone number, must be 10 digits";
      formIsValid = false;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const SHEET_WEBAPP_URL =
    "https://script.google.com/macros/s/AKfycbydPdOZccESHEkY1fnwW0th9jdeGvgBeJY7YjboLcFF78ec6PKVp4BuzJc184PB0qPz/exec";

  /**
   * Sends data to Apps Script using x-www-form-urlencoded to avoid CORS preflight.
   * If the browser still blocks reading response, we use mode:"no-cors" (fire-and-forget).
   */
  const pushToGoogleSheet = async (payload) => {
    const body = new URLSearchParams(payload);

    // Try normal fetch first (lets you see response if CORS allows)
    try {
      const res = await fetch(SHEET_WEBAPP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body,
      });

      // If CORS blocks reading, this may throw before here.
      // If it succeeds, you can optionally read JSON:
      // const data = await res.json();
      // console.log("Sheet response:", data);

      return true;
    } catch (err) {
      // Fallback: fire-and-forget (cannot read response)
      await fetch(SHEET_WEBAPP_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body,
      });
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const type = "Admission";
        const { header } = getHeader();

        // 1) Save to DB (your existing API)
        const response = await form(formData, header, type);

        // 2) Push to Google Sheet directly from frontend (best-effort)
        // NOTE: applicationNumber is generated in backend, so sheet will NOT have it in frontend-only mode.
        // If you still want applicationNumber in sheet, backend must return it, then send it here.
        await pushToGoogleSheet({
          name: formData.name || "",
          phone: formData.phone || "",
          email: formData.email || "",
          academicYear: formData.academicYear || "",
          message: formData.message || "",
          classValue: formData.class || "",
        });

        setSubmitStatus("Thank you We will be get back to you soon");

        setFormData({
          name: "",
          email: "",
          phone: "",
          class: "",
          academicYear: "",
          message: "",
        });

        setTimeout(() => {
          navigate("/admission-procedure");
        }, 1000);
      } catch (error) {
        console.error("Error submitting form:", error);
        setSubmitStatus("Please fill all fields correctly.");
      }

      setErrors({});
    } else {
      setSubmitStatus("Please fill all fields correctly.");
    }
  };

  const handleCloseForm = () => {
    setIsFormVisible(false);
    setLockClass(false);
    setFormData((prev) => ({ ...prev, class: "" }));
  };

  const classOptions = Array.from({ length: 12 }, (_, index) => index + 1).filter(
    (cls) => cls !== 10 && cls !== 12 && cls !=1 && cls !=2 && cls !=3,
  );

  useEffect(() => {
    const handleOpenAdmissionForm = (event) => {
      const classValue = event?.detail?.classValue || "";
      const shouldLockClass = Boolean(event?.detail?.lockClass);

      setIsFormVisible(true);
      if (classValue) {
        setFormData((prev) => ({ ...prev, class: classValue }));
      }
      setLockClass(shouldLockClass);
    };

    window.addEventListener("openAdmissionForm", handleOpenAdmissionForm);
    return () => {
      window.removeEventListener("openAdmissionForm", handleOpenAdmissionForm);
    };
  }, []);

  if (location.pathname === "/admission-procedure" || !isFormVisible) {
    return null;
  }

  return (
    <div className="admission-block">
      <form onSubmit={handleSubmit}>
        <center>
          <h3>Admission Enquiry</h3>
        </center>
        <div className="close" onClick={handleCloseForm}>
          <i class="bi bi-x"></i>
        </div>
        <div>
          <label>
            Student Name <span>*</span>
          </label>
          <input
            type="text"
            placeholder="Full Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <div className="text-danger">{errors.name}</div>}
        </div>
        <div>
          <label>Email Id (Parent's)</label>
          <input
            type="email"
            placeholder="Email Id"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <div className="text-danger">{errors.email}</div>}
        </div>
        <div>
          <label>
            Mobile Number (Parent's) <span>*</span>
          </label>
          <input
            type="tel"
            placeholder="Mobile Number"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            maxLength={10}
          />
          {errors.phone && <div className="text-danger">{errors.phone}</div>}
        </div>
        <div>
          <label>
            Academic Year <span>*</span>
          </label>
          <select
            name="academicYear"
            value={formData.academicYear}
            onChange={handleChange}
          >
            <option>Select Academic Year</option>
            <option>2026-2027</option>
          </select>
          {errors.academicYear && (
            <div className="text-danger">{errors.academicYear}</div>
          )}
        </div>
        <div>
          <label>
            Admission For Class <span>*</span>
          </label>
          <select
            name="class"
            value={formData.class}
            onChange={handleChange}
            disabled={lockClass}
          >
            {!lockClass && <option value="">Select Class</option>}

            {classOptions.map((cls) => (
              <option key={cls} value={cls}>
                {cls}
              </option>
            ))}
          </select>

          {errors.phone && <div className="text-danger">{errors.phone}</div>}
        </div>
        <div>
          <label>Message</label>
          <textarea
            row="4"
            name="message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>
        <div>
          <input type="submit" value="SUBMIT"></input>
          {submitStatus && <div className="feedback">{submitStatus}</div>}
        </div>
      </form>
    </div>
  );
};

export default FormAdmissionHome;
